<template>
  <select class="w-full bg-gray-100 rounded-lg p-2 my-2"
          :value="modelValue"
          @input="$emit('update:modelValue', $event.target.value);">
    <slot> </slot>
  </select>
</template>

<script>
export default {
  name: "Select",
  props: ['modelValue'],
  emits: ['update:modelValue'],
}
</script>

<style scoped>

</style>